/**
 * The viewer's IANA time zone (e.g. "America/New_York"), or undefined when the
 * runtime can't report one.
 *
 * The my_metrics endpoints bucket personal readings into calendar months in
 * this zone, so a check-in late on the 31st lands in the month the viewer saw
 * on their own clock. The API falls back to UTC when the zone is missing.
 */
export const currentTimeZone = (): string | undefined => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || undefined;
  } catch {
    return undefined;
  }
};
